// @flow strict

import React from 'react';
import PropTypes from 'prop-types';
import { useLanguageContext } from '~contexts/language-context';

import * as styles from './productItem.module.less';

export const ProductItem = ({ data }) => {
  const { loc, language } = useLanguageContext();

  return (
    <a
      href={data.href}
      className={`${styles.menuTitle}${data.highlight ? ` ${styles.highlighted}` : ''}`}
    >
      <img
        className={styles.image}
        src={data.image.src.publicURL}
        alt={data.image.alt}
      />
      <p className={styles.titleName}>{data.name}</p>
      <p>{data.text}</p>
    </a>
  );
};

ProductItem.propTypes = {
  data: PropTypes.object,
};
